// extracted by mini-css-extract-plugin
export var colProjectInfo = "project-module--colProjectInfo--c5266";
export var companyItem = "project-module--companyItem--7af5f";
export var ctaTopic = "project-module--ctaTopic--0e0b1";
export var headerText = "project-module--headerText--0c639";
export var horizontal = "project-module--horizontal--3c9f5";
export var image = "project-module--image--c244e";
export var infoProject = "project-module--infoProject--89a65";
export var label = "project-module--label--42fe8";
export var linesWithImage = "project-module--linesWithImage--acdc4";
export var projectDetail = "project-module--projectDetail--8efce";
export var projectHero = "project-module--projectHero--840b8";
export var square = "project-module--square--7cd09";
export var subtitle = "project-module--subtitle--06f10";
export var vertical = "project-module--vertical--80503";